

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { AuthService } from './authservice.service';
import { ToastrService } from 'ngx-toastr';
import { TokenStorageService } from './token-storage.service';
import { Router } from '@angular/router';
import { CommonService1, CommonService2 } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public datatoken = new BehaviorSubject('');
  currentDatatoken = this.datatoken.asObservable();

  updateMessagetoken(item: any) {
    this.datatoken.next(item);
  }

  public datawithouttoken = new BehaviorSubject('');
  currentDatawithouttoken = this.datawithouttoken.asObservable();

  updateMessagewithouttoken(item: any) {
    this.datawithouttoken.next(item);
  }


  currentuser: any;


  constructor(private authService: AuthService, private tokenStorage: TokenStorageService,
    private toastr: ToastrService, private router: Router, private _service: CommonService1, private _service1: CommonService2
  ) {

    // this.subscription = this.currentData.subscribe(x => this.check(null)); //use for call when no. verified
    this.currentDatatoken.subscribe(x => {

      if (x != '') {
        this.getUserdetailsbytoken(x);
      }
    });

    this.currentDatawithouttoken.subscribe(x => {

      if (x != '') {
        this.check(x);
      }

    });
  }

  ngOnInit(): void {

  }


  check(val: any) {

    var body = {
      serviceId: val.serviceid,
      userid: val.userid
    }
    ;
    this.authService.getUserdetails(body).subscribe(
      x1 => {
        var response = {
          serviceProvider1: x1.apiData.countryCurrency.trim(),
          serviceid: x1.apiData.serviceid,
          firstname: x1.apiData.firstName,
          lastname: x1.apiData.lastName,

          fullusername: x1.apiData.firstName + ' ' + x1.apiData.lastName,
          MobileNo: x1.apiData.mobileno,

          mobileotpstatus: x1.apiData.mobilenostatus,
          emailConfirmed: x1.apiData.emailidstatus,

          profileImage: x1.apiData.profileImage,
          userName: x1.apiData.emailid,
          email: x1.apiData.emailid,
          kycstatus: x1.apiData.kycstatus,
          countryName: x1.apiData.countryName,
          countrylogo: x1.apiData.countrylogo,
          userid: x1.apiData.userid,
          //serverName: x1.apiData.serverName,
          emailsus: x1.apiData.emailsus,
          visitus: x1.apiData.visitus,
          customerService: x1.apiData.customerService,
          whatsappSupport: x1.apiData.whatsappSupport,
          companyname: x1.apiData.companyname,
          userRole: x1.apiData.userRole,
          merchantDoc_status: x1.apiData.merchantDoc_status
        };
        
        localStorage.setItem('emailsus', x1.apiData.emailsus);
        localStorage.setItem('visitus', x1.apiData.visitus);

        localStorage.setItem('customerService', x1.apiData.customerService);
        
        localStorage.setItem('whatsappSupport', x1.apiData.whatsappSupport);
        localStorage.setItem('companyname', x1.apiData.companyName);
        localStorage.setItem('companyaddress', x1.apiData.companyaddresss);
        localStorage.setItem('countrylogo', x1.apiData.countrylogo);
        localStorage.setItem('countryIsdcode1', x1.apiData.countryIsdcode);
        this.tokenStorage.saveUser(response);

        this.tokenStorage.updateMessage1(this.tokenStorage.getUser());

        ////////console.log(this.tokenStorage.getUser());

        if (val.currentUserserviceid != null || val.currentUserserviceid != undefined) {
          //  this.toastr.success(val.apiMessage, 'Success');
          //  //this.tokenStorage.isUserLoggedIn.next(true);
          // this.router.navigate(['/Go-on']);
          
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/Go-on']);
          });
        }
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });

  }

  ///when user details gets it set userinfo & the get services option & get user cuurenft bal
  getUserdetailsbytoken(text: any) {

    this.authService.getUserdetailsbytoken().subscribe((x1: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger;
      //////console.log(x1.apiData);
      if (x1.apiStatus == false) {
        this.toastr.error(x1.apiMessage, 'Error');
      }
      else {
      


        var response = {
          firstname: x1.apiData.FirstName,
          lastname: x1.apiData.lastName,

          fullusername: x1.apiData.FirstName + ' ' + x1.apiData.lastName,
          MobileNo: x1.apiData.Mobileno,

          mobileotpstatus: x1.apiData.mobilenostatus,
          emailConfirmed: x1.apiData.emailidstatus,
          userName: x1.apiData.emailid,
          email: x1.apiData.emailid,
          userid: x1.apiData.userid
        };

        if (text != 'token') {
          localStorage.setItem('countryIsdcode', text);
        }
        
        //response.countrylogo = localStorage.getItem('countrylogo');

        this.tokenStorage.saveUser(response);

        this.tokenStorage.updateMessage1(this.tokenStorage.getUser());
        this._service1.callMethodOfBalComponent(); //bal 

        //      if (this.tokenStorage.getToken()) {         
        this.getUserdetailsCurrBal(x1.apiData.serviceid);
        //    }
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  //get getUserdetailsCurrBal 

  getUserdetailsCurrBal(serviceid: any) {
    //this.submitted = true;
    debugger;
    this.authService.getUserdetailsCurrBal(serviceid).subscribe((response: { apiData: any; apiStatus: any; apiMessage: any; }) => {
      debugger;
      if (response.apiStatus == true) {
      
        var response1 = {
          currency: response.apiData.currency,
          currentBalance: response.apiData.currentBalance,

        };
        this.tokenStorage.saveUsertBal(response1);

        this.tokenStorage.updateMessage1(this.tokenStorage.getUsertBal());

        this._service.callMethodOfNotificationComponent(); //notification
        
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }









}
